;
(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	var Layout = APP.module('Layout');
	var Collection = APP.module('Collection');

	View.TippingGauntlet = View.TippingTips.extend({
		tagName: 'div',
		className: 'gauntlet',
		template: JST.ExtendedTippingGauntletForAflClubs,
		data: {},
		gauntlet_start_round: 7,
		gauntlet_end_round: 24,
		initialize: function () {
			this.round_id = this.getOption('round_id');
			this.rounds = this.getOption('rounds');
			this.squads = this.getOption('squads');
			this.venues = this.getOption('venues');
			this.formGuide = this.getOption('formGuide');
			this.getting_data = false;
			this.snapshot = [];

			this.forms = [];

			this.listenTo(APP.vent, 'tipping:round:change', _.bind(function (round_id) {
				this.setSelectedRound(round_id);
			}, this));

			var collections = [this.squads, this.venues, this.rounds],
				complete = _.invoke(collections, 'fetch', {
					cache: true,
					expires: 60
				});

			$.when.apply(null, complete).done(_.bind(function () {
				this.setSelectedRound(this.gauntlet_start_round);
			}, this));

		},

		ui: {
			tip: '.js-tip',
			active_tip: '.js-tip.active',
			days: '.days',
			form_guide_container: '.js-form-guide-container',
			save_selection: '.js-save-selection',
			round_match: '.js-round-match',
			home_points: '.js-home-points',
			away_points: '.js-away-points',
			tip_home: '.js-tip-home',
			tip_away: '.js-tip-away',
			gauntlet_full: '.js-gauntlet-full',
			tip_item: '.round-content-area'
		},

		events: {
			"click @ui.tip": "updateGauntletStatus",
			"click @ui.save_selection": "updateGauntletStatusFull",
			"mouseover @ui.tip_item": "highlightTeams",
			"mouseout @ui.tip_item": "removeHighlightTeams",
			"click @ui.next_round": "test"
		},

		highlightTeams: function (e) {

			var $this = $(e.currentTarget),
				home = $this.find('.round-contents-left').data('predict_winner_squad_id'),
				away = $this.find('.round-contents-right').data('predict_winner_squad_id');

			$('.round-ladder').find('#squad-' + home + ', #squad-' + away).addClass('highlight')
		},

		removeHighlightTeams: function (e) {
			$('.round-ladder').find('.highlight').removeClass('highlight');
		},

		addFormGuide: function () {
			_.each($(this.ui.form_guide_container), _.bind(function (container) {
				var $container = $(container);
				new View.TippingFromGuide({
					el: $container,
					formGuide: this.formGuide,
					match_id: $container.data('match_id'),
					hide_odds: true
				}).setTemplateData();
			}, this));

			_.each($(this.ui.gauntlet_full), _.bind(function (container) {
				var $container = $(container);
				new View.AflClubsGauntletFull({
					el: $container,
					rounds: this.rounds,
					squads: this.squads
				}).setTemplateData();
			}, this));

			return this;
		},

		onRequest: function (saving) {
			var _this = this;
			$.when
				.call(null, saving)
				.done(_.bind(function () {
					setTimeout(function () {
						_this.getGauntletTips();
					}, 500);
				}, this));
		},

		updateGauntletStatusFull: function () {

			var $tip = $(document).find('.game-part.active'),
				data = $tip.data();

			if (!data) {
				APP.vent.trigger('popup:message:show', 'You should select squad first!');
				return false;
			}

			var result = this.model.save_gauntlet({
				round: this.round_id,
				predict_winner_squad_id: data.predict_winner_squad_id
			});

			this.onRequest(result);

		},

		checkForTeam: function (round, squad) {
			var save = true,
				already_in_streak = false,
				result;

			for (var i = 0; i < this.snapshot.length; i++) {
				if (this.snapshot[i].round != round && this.snapshot[i].predict_winner_squad_id == squad) {
					already_in_streak = true;
					break;
				}
				if (this.snapshot[i].round == round && this.snapshot[i].predict_winner_squad_id == squad) {
					save = false;
					break;
				}
			}

			if (already_in_streak) {
				APP.vent.trigger('popup:message:show', 'You already selected this team in another round');
			} else {

				if (save) {
					result = this.model.save_gauntlet({
						round: this.round_id,
						predict_winner_squad_id: squad
					});
				} else {
					result = this.model.remove_gauntlet({
						round: round
					});
				}

				this.onRequest(result);
			}
		},

		updateGauntletStatus: function (e) {

			var $tip = $(e.currentTarget),
				data = $tip.data();

			this.checkForTeam(this.round_id, data.predict_winner_squad_id);

		},

		setSelectedRound: function (round_id) {
			console.log(round_id);

			if (!this.rounds || round_id === this.round_id) {
				return this;
			}

			// Gauntlet should starts from Round 5
			if (round_id && round_id <= this.gauntlet_start_round) {
				round_id = this.gauntlet_start_round;
			}

			if (round_id && round_id >= this.gauntlet_end_round) {
				round_id = this.gauntlet_end_round;
			}

			this.round_id = round_id ? round_id : this.rounds.getActualRoundId();
			this.selected_round = this.rounds.get(this.round_id);

			this.extendSelectedRound();

			this.collection.show_my_list().fetch({
				data: {
					round: this.round_id
				}
			}).done(
					_.bind(function () {
						this.getGauntletTips();
						this.hidePreloader();
					}, this)
				);

			return this;
		},

		getGauntletTips: function () {

			var matches = this.selected_round.get('matches'),
				_this = this;

			this.model
				.loadSnapshot()
				.fetch()
				.done(function (response) {

					response.get = function (k) {
						if (this.result[k]) {
							return this.result[k]
						} else {
							return null
						}
					};


					var sended = response.get('sended');
					_this.snapshot = response.get('sended');

					// Remove all selections
					_.map(matches, function (match) {
						delete match.home_gauntlet_data;
						delete match.away_gauntlet_data;
						delete match.is_selected_home;
						delete match.is_selected_away;
					});

					// Set new selections
					_.map(matches, function (match) {

						for (var i = 0; i < sended.length; i++) {
							if (sended[i].predict_winner_squad_id == match.home_squad_id) {
								match.home_gauntlet_data = sended[i];
								if (_this.selected_round.id == sended[i].round) {
									match.is_selected_home = true;
								}
							}
							if (sended[i].predict_winner_squad_id == match.away_squad_id) {
								match.away_gauntlet_data = sended[i];
								if (_this.selected_round.id == sended[i].round) {
									match.is_selected_away = true;
								}
							}
						}

					});

					_this.setTemplateData({
						image_url: _this.image_url,
						round_id: _this.round_id - 1,
						rounds: _this.rounds.toJSON(),
						selected_round: _this.selected_round.toJSON(),
						matches: matches,
						img_url: _this.project_img_url,
						SQUADS_URL: CONFIG.SQUADS_URL
					});

				});

			return this;
		},

		render: function () {
			var $this = this;

			if (!this.getting_data) {
				return this;
			}

			this.$el.html(this.template(this.data));

			this.addFormGuide();
			this.onAfterRender();

			return $this;
		},

		onAfterRender: function () {

			//Remove all rounds before 5
			var rounds = $(document).find('.select-round'),
				_this = this;

			for(var i = 1; i < this.gauntlet_start_round; i++) {
				rounds.find('[data-round-id="'+ i + '"]').remove();
			}
			rounds.find('[data-round-id="' + this.round_id + '"]').addClass('selected');
			rounds.find('.current-round span').html(this.round_id);
			this.selected_round = this.rounds.get(this.round_id);

			$('.js-next-round').on('click', function (e) {

				var round = parseInt(rounds.find('.current-round span').text());
				if (round < _this.gauntlet_end_round)
					_this.setSelectedRound(round + 1);

				return false;
			});

			$('.js-prev-round').on('click', function (e) {

				var round = parseInt(rounds.find('.current-round span').text());
				if (round > _this.gauntlet_start_round)
					_this.setSelectedRound(round - 1);

				return false;
			});

		}

	});

}(window, APP, Backbone, Marionette, $, _));
